<template>
    <div>


        <!-- Start Blog Details Area -->
        <section class="blog-details-area ptb-80 mt-5">
            <div class="container">
                <div class="row">
                    <div class="col-lg-8 col-md-12">
                        <div class="blog-details-desc">
                            <div class="article-image">
                                <img src="../../../../assets/img/blog-image/5.jpg" alt="image">
                            </div>

                            <div class="article-content">
                                <div class="entry-meta">
                                    <ul>
                                        <li><feather type="clock"></feather> <a href="#">September 31, 2020</a></li>
                                        <li><feather type="user"></feather> <a href="#">Steven Smith</a></li>
                                    </ul>
                                </div>

                                <h3>How can eCommerce help your business?</h3>

                                <p>There is no doubt that the ever-increasing e-commerce market is the upcoming future for buying and selling. Here are some good points to consider why your business needs an eCommerce website.</p>
                                <p>80% of the web population has already purchased online so it is your chance now to take advantage of this to increase your business. When you invest in e-commerce websites you widen your audience reach which will help your business grow rapidly. The secret for success of e-commerce is, it influences purchase decisions of the customers. Your store promotions become a lot easier with e-commerce. </p>
                                <p>When you invest in e-commerce websites you widen your audience reach which will help your business grow rapidly.</p>
                                <p>The secret for success of e-commerce is, it influences purchase decisions of the customers.</p>
                                <p>Your store promotions become a lot easier with e-commerce.</p>
                        </div>
                    </div>

                    
                </div>
                 <div class="col-lg-4 col-md-12">
                        <aside class="widget-area" id="secondary">
                            <section class="widget widget_search">
                                <form class="search-form">
                                    <label>
                                        <span class="screen-reader-text">Search for:</span>
                                        <input type="search" class="search-field" placeholder="Search...">
                                    </label>
                                    <button type="submit"><feather type="search"></feather></button>
                                </form>
                            </section>

                            <section class="widget widget_startp_posts_thumb">
                                <h3 class="widget-title">Popular Posts</h3>

                                <article class="item">
                                    <router-link to="/blog-details/WhyECommerce" class="thumb">
                                        <span class="fullimage cover bg1" role="img"></span>
                                    </router-link>
                                    <div class="info">
                                        <time datetime="2021-06-30">June 10, 2021</time>
                                        <h4 class="title usmall"><router-link to="/blog-details/WhyECommerce">How can eCommerce help your business?</router-link></h4>
                                    </div>

                                    <div class="clear"></div>
                                </article>

                                <article class="item">
                                    <router-link to="/blog-details/NeedWebSide" class="thumb">
                                        <span class="fullimage cover bg2" role="img"></span>
                                    </router-link>
                                    <div class="info">
                                        <time datetime="2021-06-30">June 21, 2021</time>
                                        <h4 class="title usmall"><router-link to="/blog-details/NeedWebSide">Why does your business need a website?</router-link></h4>
                                    </div>

                                    <div class="clear"></div>
                                </article>

                                <article class="item">
                                    <router-link to="/blog-details/NeedDigitalMarketing" class="thumb">
                                        <span class="fullimage cover bg3" role="img"></span>
                                    </router-link>
                                    <div class="info">
                                        <time datetime="2021-06-30">June 30, 2021</time>
                                        <h4 class="title usmall"><router-link to="/blog-details/NeedDigitalMarketing">Why does your business need digital marketing?</router-link></h4>
                                    </div>

                                    <div class="clear"></div>
                                </article>
                                
                                <article class="item">
                                    <router-link to="/blog-details/WhyRestudent" class="thumb">
                                        <span class="fullimage cover bg4" role="img"></span>
                                    </router-link>
                                    <div class="info">
                                        <time datetime="2021-06-30">June 30, 2021</time>
                                        <h4 class="title usmall"><router-link to="/blog-details/WhyRestudent">Why does your restaurant need an online website?</router-link></h4>
                                    </div>

                                    <div class="clear"></div>
                                </article>
                                
                                <article class="item">
                                    <router-link to="/blog-details/AppVsWeb" class="thumb">
                                        <span class="fullimage cover bg5" role="img"></span>
                                    </router-link>
                                    <div class="info">
                                        <time datetime="2021-06-30">June 30, 2021</time>
                                        <h4 class="title usmall"><router-link to="/blog-details/AppVsWeb">App vs Website: which one is better?</router-link></h4>
                                    </div>

                                    <div class="clear"></div>
                                </article>
                                
                                <article class="item">
                                    <router-link to="/blog-details/NeedApps" class="thumb">
                                        <span class="fullimage cover bg6" role="img"></span>
                                    </router-link>
                                    <div class="info">
                                        <time datetime="2021-06-30">June 30, 2021</time>
                                        <h4 class="title usmall"><router-link to="/blog-details/NeedApps">Why does your business need an app?</router-link></h4>
                                    </div>

                                    <div class="clear"></div>
                                </article>
                            </section>
                        </aside>
                    </div>
            </div>
            </div>
        </section>
        <!-- End Blog Details Area -->
    </div>
</template>

<script>
export default {
    name: 'WhyECommerce'
}
</script>